import {TableHeaderItem} from "@/views/components/YtoTable/TableHeaderItem";

import {date_day_add, parseTime, showLabel} from "@/utils";
// const defaultWidth = 120;

const pintedResultTableHeader: TableHeaderItem[] = [
  {prop: "index", label: "序号", width: null},
  {prop: "packageName", label: "包名称", width: null},
  {prop: "packageType", label: "拆包组织名称", width: null},
  {prop: "waybillNo", label: "建包类型", width: null},
  {prop: "ext1", label: "打印数量", width: null}
];

const searchResultTableHeader: TableHeaderItem[] = [
  {prop: "waybillNo", label: "包签号", width: null},
  {prop: "packageName", label: "包名称", width: null},
  {prop: "takeApartOrgName", label: "拆包地", width: null},
  {
    prop: "packageType", label: "建包类型", width: null, format: (value) => {
      return showLabel(value, packageTypes)
    }
  },
  {prop: "productType", label: "产品类型", width: null},
  {prop: "downloadTime", label: "打印时间", width: 220},
  {prop: "expireTime", label: "过期时间", width: 220},
  {prop: "matOrgCode", label: "操作网点", width: null},
  {prop: "createUserName", label: "操作人", width: null}
];
const packageTypes = [
  {label: '汽运', value: 'QY'},
  {label: '航空', value: 'HK'},
];

export default {pintedResultTableHeader, searchResultTableHeader, packageTypes};
